/* global translations */
/* eslint no-underscore-dangle: ["error", { "allow": ["_this"] }] */
import React from 'react';
import $ from 'jquery';
// import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ImageSvg } from '../image';
import PermissionsStore from '../../stores/PermissionsStore';

class PermissionsReminderNew extends React.Component {
  state = {
    isInstructionsShown: PermissionsStore.isInstructionsShown(this.props.type),
  };

  componentDidMount() {
    // const reminder = this.refs.reminder;
    const reminder = this.reminderNew;
    const _this = this;
    reminder.addEventListener('animationend', function () { // eslint-disable-line func-names, prefer-arrow-callback
      _this.props.finishAnimation(_this.props.type);
    });
  }

  componentWillUnmount() {
    // const reminder = this.refs;
    const reminder = this.reminderNew;
    const _this = this;
    reminder.removeEventListener('animationend', function () { // eslint-disable-line func-names, prefer-arrow-callback
      _this.props.finishAnimation(_this.props.type);
    });
  }

  handleClick = () => {
    if (this.state.isInstructionsShown) {
      PermissionsStore.hideInstructions(this.props.type);
      this.setState({
        isInstructionsShown: false,
      });
      $('.overlay-main').addClass('hide');
    } else {
      PermissionsStore.showInstructions(this.props.type);
      this.setState({
        isInstructionsShown: true,
      });
    }
  };

  render() {
    const { isInstructionsShown } = this.state;
    const { type, animate } = this.props;

    //
    const classNames = [
      'permissionsReminder',
      `permissionsReminder permissionsReminder--${type}`,
    ];

    //
    if (animate) {
      classNames.push('permissionsReminder--fall-down');
    }

    //
    if (!isInstructionsShown) {
      classNames.push('tooltip');
      classNames.push('tooltip--xxl');
    }

    //
    return (
      <div
        role="presentation"
        ref={(el) => { this.reminderNew = el; }}
        className={classNames.join(' ')}
        onClick={this.handleClick}
        data-tooltip={translations['txt: Esi nobloķējis piekļuvi savai atrašanās vietai']}
      >
        <ImageSvg svg="icon-location" />
      </div>
    );
  }
}

PermissionsReminderNew.propTypes = {
  animate: PropTypes.bool,
  type: PropTypes.string,
};

PermissionsReminderNew.defaultProps = {
  animate: false,
  type: '',
};

export default PermissionsReminderNew;
